import CustomTable from '../Table';
import SkeletonLoader from './index';

interface ITeacherLessonDetailsSkeletonProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: any[];
}

const TeacherLessonDetailsSkeleton = ({
  columns,
}: ITeacherLessonDetailsSkeletonProps) => {
  return (
    <div className="flex flex-col gap-6">
      {/* Top Bar: Search and Action Button */}
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-4 flex-1">
          {/* Search Input Skeleton */}
          <SkeletonLoader className="h-12 w-70 rounded-lg" variant="rect" />
          <SkeletonLoader className="h-12 w-40 rounded-lg" variant="rect" />
        </div>
        {/* Action Button Skeleton */}
      </div>

      {/* Lesson Details Cards Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Column: Lesson Details (Orange Card) */}
        <div className="w-full p-4 bg-orange-50 rounded-2xl flex flex-col gap-4 border border-orange-100">
          {/* Header: Icon + Title */}
          <div className="flex items-center gap-3">
            <SkeletonLoader
              width={32}
              height={32}
              className="rounded-lg bg-orange-200"
            />
            <SkeletonLoader width={200} height={24} className="bg-orange-200" />
          </div>

          {/* Dates */}
          <div className="flex gap-10">
            <div className="flex flex-col gap-2">
              <SkeletonLoader
                width={80}
                height={14}
                className="bg-orange-200"
              />
              <SkeletonLoader
                width={120}
                height={18}
                className="bg-orange-200"
              />
            </div>
            <div className="flex flex-col gap-2">
              <SkeletonLoader
                width={80}
                height={14}
                className="bg-orange-200"
              />
              <SkeletonLoader
                width={120}
                height={18}
                className="bg-orange-200"
              />
            </div>
          </div>

          {/* Progress Bar Section */}
          <div className="flex flex-col gap-2">
            <div className="flex justify-between">
              <SkeletonLoader
                width={100}
                height={16}
                className="bg-orange-200"
              />
              <SkeletonLoader
                width={40}
                height={16}
                className="bg-orange-200"
              />
            </div>
            <SkeletonLoader
              height={8}
              className="w-full rounded-full bg-orange-200"
            />
          </div>

          {/* Summary Cards Grid */}
          <div className="grid sm:grid-cols-3 gap-4">
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="bg-white rounded-xl p-3 flex flex-col gap-2 h-20"
              >
                <SkeletonLoader width={80} height={14} />
                <SkeletonLoader width={60} height={20} className="mt-auto" />
              </div>
            ))}
          </div>
        </div>

        {/* Right Column: Lesson Breakdown List */}
        <div className="w-full p-6 rounded-2xl border border-neutral-200 flex flex-col gap-6 bg-white h-auto">
          {/* Header */}
          <div className="flex items-center gap-3">
            <SkeletonLoader width={160} height={24} />
            <SkeletonLoader width={32} height={20} className="rounded-full" />
          </div>

          {/* List Items */}
          <div className="flex flex-col gap-4 mt-2">
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="flex items-center justify-between pb-4 border-b border-neutral-100 last:border-0 last:pb-0"
              >
                <SkeletonLoader width={180} height={20} />
                <div className="flex items-center gap-4">
                  <SkeletonLoader
                    width={80}
                    height={24}
                    className="rounded-full"
                  />
                  <SkeletonLoader variant="circle" width={24} height={24} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Table Skeleton */}
      <CustomTable columns={columns} dataSource={[]} isLoading={true} />
    </div>
  );
};

export default TeacherLessonDetailsSkeleton;
